var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',_vm._l((4),function(n){return _c('v-col',{key:n,staticClass:"mt-5",attrs:{"md":"12","sm":"12","xs":"12","lg":"12","xl":"12"}},[_c('v-skeleton-loader',_vm._b({attrs:{"type":"heading"}},'v-skeleton-loader',_vm.attrs,false)),_c('v-skeleton-loader',_vm._b({attrs:{"type":"text"}},'v-skeleton-loader',_vm.attrs,false))],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }